module.exports = __webpack_public_path__ + "static/media/logo.fcd9214b.png";